import React from 'react';
import { Text, Container, Sticky, Link, Message } from 'basis';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import { Header } from 'components/header/Header';
import { Footer } from 'components/footer/Footer';
import { YellowMessage } from 'components/message/YellowMessage';
import { config, PRODUCT_CODE_DAVID_JONES_PREMIERE } from '_config';
import { getFeatureValue } from 'featureToggles';
import { isDJ } from 'utils/byConfig';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  width: 100%;
`;

const ContentWrapper = styled.div`
  max-width: 600px;
  min-height: 500px;
  margin: ${props => (props.margin ? props.margin : '16px')};
`;

function MaintenanceNotice({ notice }) {
  // Only allow https links from the flag
  const hasLink = /^https:\/\//i.test(notice.link || '');
  const textColor = isDJ() ? 'indigo' : undefined;

  return (
    <YellowMessage>
      <Message testId="yellow-message" severity="warning-or-significant">
        <Text color={textColor}>
          <b>{notice.title}</b>
        </Text>
        {hasLink && (
          <Text margin="2 0 0 0">
            <Link href={notice.link} newTab>
              {notice.linkText || 'Find out more.'}
            </Link>
          </Text>
        )}
      </Message>
    </YellowMessage>
  );
}

export function Maintenance() {
  const theme = useTheme();
  // DJ pages without a product code (comparison page, QR links) use the Premiere message
  const productCode = config.productCode || (isDJ() ? PRODUCT_CODE_DAVID_JONES_PREMIERE : undefined);
  const message = getFeatureValue('maintenanceMessage')?.[productCode];
  const notice = message?.title ? message : null;

  return (
    <>
      <Sticky>
        <Sticky.Item>
          <Header />
        </Sticky.Item>
        <Container padding="12 0" testId="error" hasBreakpointWidth>
          <Wrapper>
            <ContentWrapper>
              {notice ? (
                <MaintenanceNotice notice={notice} />
              ) : (
                <>
                  <Container padding="8 0 0 0">
                    <Text as="h5" textStyle="heading5" color={theme.headingColor} align="left">
                      Our application is currently undergoing maintenance
                    </Text>
                    <p hidden>CF flush from inactive is working</p>
                  </Container>

                  <Container padding="8 0">
                    <Text as="p">{typeof message === 'string' ? message : null}</Text>
                  </Container>
                </>
              )}
            </ContentWrapper>
          </Wrapper>
        </Container>
      </Sticky>
      <Footer footer="OVERVIEW" />
    </>
  );
}
